// S(9) Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "John", location: "NY", product: "S(9) Bundle 1", time: "14 minutes ago" },
    { name: "Alex", location: "FL", product: "S(9) Bundle 1", time: "15 minutes ago" },
    { name: "Benjamin", location: "MA", product: "S(9) Bundle 1", time: "28 minutes ago" },
    { name: "Norma", location: "TX", product: "S(9) Bundle 1", time: "41 minutes ago" },
    { name: "Craig", location: "NY", product: "S(9) Bundle 1", time: "55 minutes ago" },
    { name: "Krystel", location: "FL", product: "S(9) Bundle 1", time: "1 hour 9 minutes ago" },
    { name: "Alicia", location: "UT", product: "S(9) Bundle 1", time: "1 hour 23 minutes ago" },
    { name: "Emily", location: "FL", product: "S(9) Bundle 2", time: "31 minutes ago" },
    { name: "Patrice", location: "AL", product: "S(9) Bundle 2", time: "16 minutes ago" },
    { name: "Leticia", location: "CA", product: "S(9) Bundle 2", time: "29 minutes ago" },
    { name: "Francisco", location: "TX", product: "S(9) Bundle 2", time: "43 minutes ago" },
    { name: "Ariana", location: "AZ", product: "S(9) Bundle 2", time: "58 minutes ago" },
    { name: "Marian", location: "TX", product: "S(9) Bundle 2", time: "1 hour 13 minutes ago" },
    { name: "Tiffini", location: "TX", product: "S(9) Bundle 2", time: "1 hour 28 minutes ago" },
    { name: "Carmen", location: "NM", product: "S(9) Bundle 2", time: "1 hour 45 minutes ago" },
    { name: "Ed", location: "CT", product: "S(9) 1 Bottle", time: "47 minutes ago" },
    { name: "James", location: "TX", product: "S(9) 2 Bottles", time: "17 minutes ago" },
    { name: "Jane", location: "QLD", product: "S(9) 6 Bottles", time: "33 minutes ago" },
    { name: "Frank", location: "FL", product: "S(9) 1 Bottle", time: "48 minutes ago" },
    { name: "Glenda", location: "CA", product: "S(9) 1 Bottle", time: "1 hour 4 minutes ago" },
    { name: "Atrayo", location: "NV", product: "S(9) 2 Bottles", time: "1 hour 21 minutes ago" },
    { name: "Brian", location: "FL", product: "S(9) 3 Bottles", time: "1 hour 37 minutes ago" },
    { name: "Rustin", location: "LA", product: "S(9) 3 Bottles", time: "1 hour 54 minutes ago" },
    { name: "Roosevelt", location: "GA", product: "S(9) 1 Bottle", time: "18 minutes ago" },
    { name: "Petra", location: "CA", product: "S(9) 1 Bottle", time: "35 minutes ago" },
    { name: "Jewel", location: "TX", product: "S(9) 1 Bottle", time: "52 minutes ago" },
    { name: "Patryce", location: "CA", product: "S(9) 1 Bottle", time: "1 hour 9 minutes ago" },
    { name: "Alex", location: "FL", product: "S(9) 1 Bottle", time: "1 hour 27 minutes ago" },
    { name: "Marcel", location: "GA", product: "S(9) 1 Bottle", time: "1 hour 45 minutes ago" },
    { name: "Paola", location: "FL", product: "S(9) 3 Bottles", time: "2 hours 3 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="${randomOrder.product.includes('Bundle 1') 
              ? 'https://cdn.shopify.com/s/files/1/2443/2395/files/The_Anti_Aging_Bundle_Zoom.png?v=1733434944' 
              : randomOrder.product.includes('Bundle 2') 
                  ? 'https://cdn.shopify.com/s/files/1/2443/2395/files/Cell_Restoration_Bundle.png?v=1732605875' 
                  : 'https://cdn.shopify.com/s/files/1/2443/2395/files/S9_Resveratrol_Zoom.png?v=1733434944'}" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;

    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
